interface OnboardingAuthUser {
    email?: string
    name?: string
    nylasEmails?: Array<{
        email?: string
        isPrimary?: boolean
        emailTemplates?: {
            signatureLogoUrl?: string
            bodyTemplates?: Array<{ type?: string; subject?: string; body?: string }>
        }
    }>
    emailTemplates?: {
        bodyTemplates?: Array<{ type?: string; subject?: string; body?: string }>
        signatureLogoUrl?: string
    }
    application?: {
        settings?: {
            company?: {
                name?: string
                mcNumber?: string
            }
        }
    }
}

/**
 * Reads the authenticated user from loadops_auth_data (synchronous).
 * Used for onboarding skip-logic so we can return <Navigate> before rendering.
 */
export const getOnboardingAuthUser = (): OnboardingAuthUser | null => {
    try {
        const raw = localStorage.getItem('loadops_auth_data')
        if (!raw) return null
        const parsed = JSON.parse(raw)
        return parsed?.user ?? null
    } catch {
        return null
    }
}
